// Detect browser RTL scrollLeft behavior: 'default' | 'negative' | 'reverse'.
// Caches the result for performance.
let rtlScrollType: 'default' | 'negative' | 'reverse' | null = null;

/**
 * Detects the browser's RTL scroll type.
 * - 'default': scrollLeft = 0 (left), max (right)
 * - 'negative': scrollLeft = 0 (right), negative (left)
 * - 'reverse': scrollLeft = max (left), 0 (right)
 */
export function detectRTLOffsetType(): 'default' | 'negative' | 'reverse' {
    if (rtlScrollType) return rtlScrollType;
    if (typeof document === 'undefined') return 'default';

    const el = document.createElement('div');
    el.dir = 'rtl';
    el.style.width = '100px';
    el.style.height = '100px';
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';

    const child = document.createElement('div');
    child.style.width = '200px';
    child.style.height = '100px';
    el.appendChild(child);

    document.body.appendChild(el);

    el.scrollLeft = 1;
    if (el.scrollLeft === 0) rtlScrollType = 'reverse';
    else {
        el.scrollLeft = -1;
        rtlScrollType = el.scrollLeft < 0 ? 'negative' : 'default';
    }

    document.body.removeChild(el);
    return rtlScrollType;
}
